import messageService from '../../services/messageService'

class MessageController {
  getMessagePreview = messageService.getMessagePreview
  sendMessage = messageService.sendMessage
  fetchMessages = messageService.fetchMessages
  fetchMessagesByCustomerIdPaged = messageService.fetchMessagesByCustomerIdPaged
  fetchMessageTemplates = messageService.fetchMessageTemplates
  flagMessage = messageService.flagMessage
  fetchMessageById = messageService.fetchMessageById
  searchMessages = messageService.searchMessages
}

export default new MessageController 



// WEBPACK FOOTER //
// ../src/controllers/messageController/messageController.js